import { ComponentProps, FC, KeyboardEventHandler } from "react";
import { Box, TextInput } from "@mantine/core";
import { useTranslation } from "react-i18next";

const ignoreKeyboardEvent: KeyboardEventHandler<HTMLInputElement> = (e) =>
  e.preventDefault();

export const RequiredLabel: FC<{
  label: string;
  value: ComponentProps<typeof TextInput>["value"];
}> = ({ label, value }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: "inline", position: "relative" }}>
      {t(label)}
      <TextInput
        required
        variant="unstyled"
        onKeyUp={ignoreKeyboardEvent}
        onKeyDown={ignoreKeyboardEvent}
        sx={{
          height: 0,
          bottom: 16,
          opacity: 0,
          overflow: "hidden",
          position: "absolute",
        }}
        value={value}
      />
    </Box>
  );
};
